import moment, {Moment} from 'moment';
import {PureComponent} from 'react';

import {videoTokenApi, testVideoApi} from 'api';
import {Button, LinearProgress, TwilioRoom, TwilioVideo} from 'components';
import {APP_NAME} from 'constants/app';
import {WebRTCServerSource} from 'enums';
import {mediaDevicesUtils} from 'utils';

const MAX_DURATION_SEC = 50 * 1000; // 50 sec

type State = {
    readonly roomName: string;
    readonly valueLeft: number;
    readonly intervalId: number;
    readonly endDate: Moment;
}

const initialState: State = {
    roomName: null,
    valueLeft: 100,
    intervalId: null,
    endDate: null
};

export class TestTwilioVideo extends PureComponent<unknown, State> {
    readonly state = initialState;

    get mediaConstraints() {
        return ({
            audioinput: mediaDevicesUtils.getMediaTrackConstraintSet(),
            videoinput: mediaDevicesUtils.getVideoTrackConstraintSet()
        });
    }

    componentDidMount() {
        testVideoApi.openPage(WebRTCServerSource.Twilio);
    }

    startInterval = () => {
        const {endDate} = this.state;
        const intervalId = window.setInterval(() => {
            const diff = endDate.diff(+new Date());
            if (diff < 0) {
                this.stopSession();
            } else {
                const valueLeft = diff / MAX_DURATION_SEC * 100;
                this.setState({valueLeft});
            }
        }, 100);
        this.setState({intervalId});
    };

    startSession = () => {
        testVideoApi.startSession(WebRTCServerSource.Twilio);
        const date = +new Date();
        const roomName = `${APP_NAME}-twilio-test-${date}`;
        this.setState({roomName, endDate: moment(date + MAX_DURATION_SEC), valueLeft: 100});
        setTimeout(() => {
            this.startInterval();
        });
    };

    stopSession = () => {
        const {intervalId} = this.state;
        clearInterval(intervalId);
        this.setState({roomName: null, endDate: null, valueLeft: 100});
        testVideoApi.stopSession(WebRTCServerSource.Twilio);
    };

    render() {
        const {roomName, valueLeft} = this.state;
        const {startSession, stopSession} = this;

        if (!roomName) {
            return (
                <div className='tw-text-center tw-p-4'>
                    <Button color='primary' onClick={startSession}>{'Start twilio video test'}</Button>
                </div>
            );
        }

        return (
            <div className='tw-h-full tw-min-w-256 tw-p-4'>
                <div className='tw-text-center'>
                    <Button color='primary' onClick={stopSession}>{'Stop test'}</Button>
                </div>
                <div className='tw-w-1/2 tw-mx-auto tw-my-8'>
                    <LinearProgress value={valueLeft} />
                </div>
                <div className='tw-flex tw-h-3/5'>
                    <div className='tw-flex-center tw-w-1/2 tw-h-full tw-border tw-border-default tw-mx-4'>
                        <TwilioRoom
                            roomName={roomName}
                            mediaConstraints={this.mediaConstraints}
                            getTokenFn={videoTokenApi.getPublicTwilioVideoToken}
                        >
                            {({room}) => <TwilioVideo room={room} mediaConstraints={this.mediaConstraints} />}
                        </TwilioRoom>
                    </div>
                    <div className='tw-flex-center tw-w-1/2 tw-h-full tw-border tw-border-default tw-mx-4'>
                        <TwilioRoom
                            roomName={roomName}
                            logLevel='debug'
                            mediaConstraints={this.mediaConstraints}
                            getTokenFn={videoTokenApi.getPublicTwilioVideoToken}
                        >
                            {({room}) => <TwilioVideo room={room} mediaConstraints={this.mediaConstraints} />}
                        </TwilioRoom>
                    </div>
                </div>
            </div>
        );
    }
}
